import { useState } from "react";
import { Link } from "react-router-dom";
import Sidebar from "../components/comman/Sidebar";
import TopHeader from "../components/comman/TopHeader";
import { sidebarMenus } from "../constants/sidebarMenus";
import { getCurrentUserId } from "../utils/auth";
import api from "../api/axios";
import "../css/diActiveProfile.css";
import { getSidebarMenus } from "../constants/sidebarMenus";
import { useNavigate } from "react-router-dom";
import { FaUserSlash, FaShieldAlt, FaRedoAlt } from "react-icons/fa";
import DeactiveModel from "../components/model/DeactiveModel";

export default function DeActiveProfile() {
  const currentUserId = getCurrentUserId();
  const sidebarMenus = getSidebarMenus(currentUserId);
  const [isRevolution, setIsRevolution] = useState([]);
  const [openId, setOpenId] = useState(null);
  const [showSidebar, setShowSidebar] = useState(true);
  const [activeSidebar, setActiveSidebar] = useState("deactive-profile");
  const [feedType, setFeedType] = useState("deactive-profile");
  const [showMsgDrawer, setShowMsgDrawer] = useState(false);
  const [showDeactiveModel, setShowDeactiveModel] = useState(false);
  const navigate = useNavigate();

  const profileData = [
    {
      profileTitle: "Your profile will be hidden",
      profileDiscription: "Privacy first",
      profileIcon: FaUserSlash,
    },
    {
      profileTitle: "Your data will remain safe",
      profileDiscription: "Secure Information",
      profileIcon: FaShieldAlt,
    },
    {
      profileTitle: "You can reaactivate anytime",
      profileDiscription: "full control",
      profileIcon: FaRedoAlt,
    },
  ];

  const handleDeactiveAccount = () => {
    setShowDeactiveModel(true);
  };

  return (
    <div className="container-xxl p-0">
      <div className="feed-page-wrapper">
        <TopHeader
          onToggleSidebar={() => setShowSidebar((prev) => !prev)}
          onOpenMessages={() => setShowMsgDrawer(true)}
          creditAmount={50}
          notificationCount={5}
          messageCount={0}
        />

        <div className="prime-layout-container .container-fluid">
          <div className="row">
            {!showSidebar && (
              <div
                className="left-sidebar-overlay d-md-none"
                onClick={() => setShowSidebar(true)}
              />
            )}

            <Sidebar
              showSidebar={showSidebar}
              sidebarMenus={sidebarMenus}
              activeSidebar={activeSidebar}
              feedType={feedType}
              onNavigate={(item) => {
                setActiveSidebar(item.key);
                if (item.path) {
                  navigate(item.path);
                }
              }}
            />

            <div className="col-lg-9 col-md-9 col-12 overflow-auto center-area-container">
              {/* <div className="col-lg-9 col-md-9 col-12 deactive_donation_container_center"> */}
              <div className="center-area">
                {/* <div className="w-100 pb-5"> */}
                <div className="w-100">
                  <div className="deActive_container">
                    <div className="deactive_container_section">
                      <div className="deactive_section_title">
                        <h2>Deactivate your account </h2>
                        <p>
                          Your profile will be temporarily hidden. You can
                          reactivate your account anytime by logging back in.
                        </p>
                      </div>

                      <div className="deactive_section">
                        {profileData.map((item, idx) => {
                          return (
                            <div className="deactive_profile_card" key={idx}>
                              <div className="deactive_icon">
                                <item.profileIcon />
                              </div>
                              <div className="deactive_policy">
                                <h3>{item.profileTitle}</h3>
                                <p>{item.profileDiscription}</p>
                              </div>
                            </div>
                          );
                        })}
                      </div>

                      <div className="deactive_bottom_section">
                        <div className="deactive_button">
                          {/* <button onClick={() => setShowDeactiveModel(false)}>
                            Cancel
                          </button> */}
                          <button
                            onClick={() => handleDeactiveAccount()}
                            className="deactivate-account"
                          >
                            Deactivate Account
                          </button>
                        </div>
                        <div className="deactive_hep">
                          <Link to={"/support-chat"}>
                            <p>Need Help?</p>
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>  
            </div>

            {showDeactiveModel && (
              <DeactiveModel onClose={() => setShowDeactiveModel(false)} />
            )}

          </div>
        </div>
      </div>
    </div>
  );
}
